import { alphaNumeric, decimalNumber, numeric } from 'Utils/validationUtils';
export function getFormMetaData() {
  return {
    dataColumns: [
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'merchantNumber',
        title: 'MERCHANT NUMBER',
        inputBoxWidth: '275px',
        max: 16,
        validate: numeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'acqReferenceNumber',
        title: 'ACQUIRER REFERENCE NUMBER',
        inputBoxWidth: '275px',
        max: 30,
        validate: numeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'mcc',
        title: 'MERCHANT CATEGORY CODE',
        inputBoxWidth: '275px',
        min: 4,
        max: 4,
        validate: numeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'cardNumberRk',
        title: 'CARD NUMBER',
        inputBoxWidth: '275px',
        max: 20,
        validate: numeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'transactionAmount',
        title: 'TRANSACTION AMOUNT',
        inputBoxWidth: '275px',
        max: 19,
        validate: (value) => decimalNumber(value, 18),
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'transactionCode',
        title: 'TRANSACTION CODE',
        inputBoxWidth: '275px',
        max: 4,
        validate: numeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Date',
        dateFormat: 'MM/DD/YYYY',
        columnKey: 'transactionDate',
        title: 'TRANSACTION DATE',
        inputBoxWidth: '275px',
        errorMsg: '',
      },

      {
        description: '',
        isRequired: false,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'originalTransactionReferenceNumber',
        title: 'ORIGINAL REFERENCE',
        inputBoxWidth: '275px',
        max: 30,
        validate: alphaNumeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: false,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'foreignAmount',
        title: 'ORIGINAL TRANSACTION AMOUNT',
        inputBoxWidth: '275px',
        max: 19,
        validate: (value) => decimalNumber(value, 18),
        errorMsg: '',
      },

      {
        description: '',
        isRequired: false,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'categoryInd',
        title: 'CAT INDICATOR',
        inputBoxWidth: '275px',
        min: 1,
        max: 1,
        validate: alphaNumeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'posEntryMode',
        title: 'POS ENTRY MODE',
        inputBoxWidth: '275px',
        min: 2,
        max: 2,
        validate: alphaNumeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: false,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'motoEcInd',
        title: 'MOTO EOP INDICATOR',
        inputBoxWidth: '275px',
        min: 1,
        max: 1,
        validate: alphaNumeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: false,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'universalCardholderAuthenticationFieldInd',
        title: 'UCAF INDICATOR',
        inputBoxWidth: '275px',
        min: 1,
        max: 1,
        validate: alphaNumeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: false,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'cardholderIdMethod',
        title: 'CARDHOLDER ID METHOD',
        inputBoxWidth: '275px',
        min: 1,
        max: 1,
        validate: alphaNumeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'DropDown',
        columnKey: 'paymentCurrencyAlpha',
        title: 'MERCHANT PAYMENT CURRENCY',
        inputBoxWidth: '275px',
        min: 1,
        max: 1,
        validate: alphaNumeric,
        errorMsg: '',
        list: [
          { text: 'First Chargeback', value: 'fc' }, { text: 'Second Chargeback', value: 'sc' }
        ]
      },
    ],
    title: 'Add Manual Transaction',
    primaryActionButtonText: 'Add Transaction',
    primaryButtonType: 'primary',
    secondaryButtonType: 'hollow',
    wrapperWidth: '70%',
    formWidth: '620px',
    inputBoxWidth: '275px',
    dateFormatForApi: 'YYYY-MM-DD',
  };
}
